import React from 'react';

import KitIcon from '../../assets/icons/KitIcon';
import ParentKitIcon from '../../assets/icons/ParentKitIcon';

const KitFile = (props) => {
  const {
    id,
    name,
    kitId,
    onClick,
    isParent,
    quantity,
  } = props;

  return (
    <div className='drive-folder__container' onClick={() => onClick(id)}>
      <div className='drive-folder-icon'>
        {isParent ? (
          <ParentKitIcon fontSize='large' color='var(--app-text)' />
        ) : (
          <KitIcon fontSize='large' color='var(--app-text)' />
        )}
      </div>
      <div className='drive-folder-name__container'>
        <div className='font-size-bg font-bold'>
          {`${name}${quantity > 1 ? ` (x${quantity})`: ''}`}
        </div>
        <div className='d-flex secondary font-size-sm'>
          <span className='m-l-sm'>{kitId}</span>
        </div>
      </div>
    </div>
  );
};

export default KitFile;
